<template>
    <header-body class="header-body--basic">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </header-body>
</template>

<script>
import HeaderBody from "@/sets/styles/headers/header-body.vue";

export default {
    props: {},
    components: {
        HeaderBody,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.header-body--basic {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.scroll-active {
    .header-body--basic {
        background-color: rgba(255, 255, 255, 0.8);
    }
}
</style>
